import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-minimal-layout',
  templateUrl: './minimal-layout.component.html',
  styleUrls: ['./minimal-layout.component.scss']
})

export class MinimalLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
